module.exports = __webpack_public_path__ + "static/media/stop.2566b814.mp3";